/* eslint-disable object-shorthand */
import _ from 'lodash'
import { validators } from '@blazar/tracking'
import gtm from '@blazar/tracking-google-tagmanager'
import {
  CAR_AUCTION_API_RESPONSE_SUCCESS,
  CAR_AUCTION_API_RESPONSE_FAIL,
} from 'external/reduxBits/motor/actions'
import paths from '../../routes/paths'

const isMotorAuctionLandingPage = (pathname) => pathname.startsWith(paths.CarAuction)
const isBrowser = () => typeof window !== 'undefined'

// eslint-disable-next-line no-unused-vars
const generateObjectCategory = (path = '') => {
  // Decision made 2018-09-12 by Jenny Cahier, Andreas Hedlund to hard code path.
  // const pathArray = path.split('/').filter((item) => item)
  // const generatedPath = pathArray.join(' > ')
  return 'fordon > bilar'
}

const eventView = 'view'
const name = 'motorAuction'
const integrationType = 'Nettbil'
const version = '1.0.0'
const objectCategories = [{ localId: '1020' }]
const domain = 'motor'

// 69 - User was shown the motor auction landing page
const pageView = (path) => {
  return {
    event: eventView,
    objectId: 'motorauction-landing-page',
    objectType: 'Page',
    objectCategory: generateObjectCategory(path),
    objectCategories,
    objectProductIntegrations: [{ name, integrationType, version }],
    domain,
  }
}

export const viewEventMotorAuctionLandingPage = {
  validators: validators.redux(
    '@@router/LOCATION_CHANGE',
    (action) => {
      const path = _.get(action, 'payload.location.pathname', '')
      return isMotorAuctionLandingPage(path) && isBrowser()
    },
    (action) => {
      const path = _.get(action, 'payload.location.pathname', '')
      return { path }
    },
  ),
  events: [
    gtm.event(({ accumulator }) => {
      return pageView(accumulator.path)
    }),
  ],
}

// 70 - User successfully posted car data to Nettbil and was given the success post view
const requestSuccess = (path, mileage) => {
  return {
    event: eventView,
    objectId: 'motorauction-request-success',
    objectType: 'Confirmation',
    objectCategory: generateObjectCategory(path),
    objectCategories,
    objectProductIntegrations: [{ name, integrationType, version, parameters: { mileage } }],
    domain,
  }
}

export const viewEventRequestSuccess = {
  validators: validators.redux(
    // Action to react on
    CAR_AUCTION_API_RESPONSE_SUCCESS,
    // Trigger tracking event if true
    (action) => {
      const path = _.get(action, 'payload.trackingData.path', '')
      return isMotorAuctionLandingPage(path) && isBrowser()
    },
    // Collect data "into" accumulator to send along with tracking event
    (action) => {
      const mileage = _.get(action, 'payload.trackingData.mileage', '')
      const path = _.get(action, 'payload.trackingData.path', '')
      return { path, mileage }
    },
  ),
  events: [
    gtm.event(({ accumulator }) => {
      const { path, mileage } = accumulator
      return requestSuccess(path, mileage)
    }),
  ],
}

// 71 - Something went wrong with req to register car @ Nettbil. User see error info page
const requestFail = (path, mileage, errorMessage) => {
  return {
    event: eventView,
    objectId: 'motorauction-request-fail',
    objectType: 'Error',
    objectCause: [
      {
        description: 'motorauction-request-fail',
        errorMessage: errorMessage,
      },
    ],
    objectCategory: generateObjectCategory(path),
    objectCategories,
    objectProductIntegrations: [{ name, integrationType, version, parameters: { mileage } }],
    domain,
  }
}

export const viewEventRequestFail = {
  validators: validators.redux(
    // Action to react on
    CAR_AUCTION_API_RESPONSE_FAIL,
    // Trigger tracking event if true
    (action) => {
      const path = _.get(action, 'payload.trackingData.path')
      return isMotorAuctionLandingPage(path) && isBrowser()
    },
    // Collect data "into" accumulator to send along with tracking event
    (action) => {
      const statusCode = _.get(action, 'payload.trackingData.error.statusCode')
      const errorText = _.get(action, 'payload.trackingData.error.errorText')
      const mileage = _.get(action, 'payload.trackingData.mileage')
      const path = _.get(action, 'payload.trackingData.path')
      return { statusCode, errorText, mileage, path }
    },
  ),
  events: [
    gtm.event(({ accumulator }) => {
      const { statusCode, errorText, mileage, path } = accumulator
      const errorMessage = `API: ${statusCode}: Nettbil: ${errorText}`
      return requestFail(path, mileage, errorMessage)
    }),
  ],
}
